import React from 'react';
import { Drawer, Button, Grid, TextField, Typography, MenuItem } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';
import WSSelectField from '../../Components/Select/WSSelect';
import { useForm } from 'react-hook-form';
import WSTextField from '../../Components/TextBox/WSTextBox';
import WSDateField from '../../Components/DateField/WSDateField';

interface OrderDrawerProps {
  open: boolean;
  onClose: () => void;
}

const OrderDrawer: React.FC<OrderDrawerProps> = ({ open, onClose }) => {
    
const {
    register,
    control,
    handleSubmit
}= useForm();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '60rem', padding: '1rem', top: '5rem', height: `calc(100% - 5rem)` }, // Adjust width and padding to match your design
      }}
    >
      <Grid container direction="column" spacing={2}>
        {/* Header with Close Button */}
        <Grid item container justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold" color={"green"}>
            Order Information
          </Typography>
          <WSIcons.CloseIcon onClick={onClose} sx={{ backgroundColor: 'red' }} />
        </Grid>

        {/* Table No Field with Label in the Same Line */}
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Table No</Typography>
          </Grid>
          <Grid item xs={9}>
          <WSSelectField
              rules={{ required: true }}
              {...register("tableno")}
              id="tableno"
              control={control}
              defaultValue={"0"}
              label=""
              name="tableno"
            />
          </Grid>
        </Grid>

        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Waiter Name</Typography>
          </Grid>
          <Grid item xs={6}>
          <WSSelectField
              rules={{ required: true }}
              {...register("waitername")}
              id="waitername"
              control={control}
              defaultValue={"0"}
              label=""
              name="waitername"
            />
          </Grid>
          <Grid item xs={3}>
          <WSTextField
            label={""}
            {...register("waitercode")}
            id="waitercode"
            name="waitercode"
            control={control}
            rules={{ required: false }}/>
          </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center" >
          <Grid item xs={3}>
            <Typography>First Name</Typography>
          </Grid>
          <Grid item xs={9}>
          <WSTextField
            label={""}
            {...register("firstname")}
            id="firstname"
            name="firstname"
            control={control}
            rules={{ required: false }}/>
          </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Last Name</Typography>
          </Grid>
          <Grid item xs={9}>
          <WSTextField
            label={""}
            {...register("lastname")}
            id="lastname"
            name="lastname"
            control={control}
            rules={{ required: false }}/>
          </Grid>
        </Grid>

        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Pax</Typography>
          </Grid>
          <Grid item xs={1}>
          <Typography>Adult#</Typography>
          </Grid>
          <Grid item xs={3}>
          <WSTextField
            label={""}
            {...register("adult")}
            id="adult"
            name="adult"
            control={control}
            rules={{ required: false }}/>
        </Grid>
          <Grid item xs={2}>
          <Typography>Child#</Typography>
          </Grid>
          <Grid item xs={3}>
          <WSTextField
            label={""}
            {...register("child")}
            id="child"
            name="child"
            control={control}
            rules={{ required: false }}/>
          </Grid>
        </Grid>

        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Date</Typography>
          </Grid>
          <Grid item xs={9}>
          <WSDateField
              id="date"
              name="date"
              label=""
              dateFormat="D/MM/YYYY"
              control={control}
              defaultValue={null}
              rules={{ required: true }}
              labelType="Normal"
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Remark</Typography>
          </Grid>
          <Grid item xs={9}>
          <WSTextField
            label={""}
            {...register("remark")}
            id="remark"
            name="remark"
            control={control}
            rules={{ required: false }}/>
          </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Citizen Id#</Typography>
          </Grid>
          <Grid item xs={9}>
          <WSTextField
            label={""}
            {...register("citizenid")}
            id="citizenid"
            name="citizenid"
            control={control}
            rules={{ required: false }}/>
          </Grid>
        </Grid>

        {/* Token No */}
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Date</Typography>
          </Grid>
          <Grid item xs={9}>
          <WSTextField
            label={""}
            {...register("date")}
            id="date"
            name="date"
            control={control}
            rules={{ required: false }}/>
          </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={3}>
            <Typography>Token No</Typography>
          </Grid>
          <Grid item xs={7}>
          <WSSelectField
              rules={{ required: true }}
              {...register("tokenno")}
              id="tokenno"
              control={control}
              defaultValue={"0"}
              label=""
              name="tokenno"
            />
          </Grid>
          <Grid item xs={2}>
          <Button variant="outlined"  
          color='success'
          sx={{width:'8rem',borderColor: "green", 
            color: "black",}}>
      Generate
    </Button>
          </Grid>
        </Grid>

        {/* Footer Buttons */}
        <Grid item container justifyContent="flex-end" spacing={2}>
  <Grid item>
    <Button variant="contained" color="success" sx={{ height: '3rem' }}>
      Save & Finish
    </Button>
  </Grid>
</Grid>

      </Grid>
    </Drawer>
  );
};

export default OrderDrawer;
